import * as components from './components'
import { locales } from './locales'
import { repositories } from './repositories'
import { services } from './services'
import { stores } from './stores'

export * from './types'
export { productMock } from './mocks'

export const product: {
  meta: {
    name: 'product'
    locales: typeof locales
  }
  layers: {
    stores: typeof stores
    services: typeof services
    repositories: typeof repositories
  }
  components: typeof components
} = {
  meta: {
    name: 'product',
    locales,
  },
  layers: {
    stores,
    services,
    repositories,
  },
  components,
}
